<script>

export default {
  name: 'Money',
  props: {
    value: {
      required: true,
      type: [Number, String],
      default: 0,
    },
    decimal: {
      type: Boolean,
      default: true,
    },
    prefix: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      formattedValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue, oldValue) {
        var unformatted = parseFloat(newValue.toString().replace(/[^0-9.]/g, '')).toFixed(2);
        if(!this.decimal) { unformatted = parseInt(unformatted); }
        var formatted = this.formatPrice(unformatted, this.prefix, this.decimal);
        this.formattedValue = 'loading';
        this.formattedValue = formatted;
      }
    }
  },
  methods: {
    change(evt) {
      var unformatted = parseFloat(evt.target.value.toString().replace(/[^0-9.]/g, '')).toFixed(2);
      if(!this.decimal) { unformatted = parseInt(unformatted); }
      var formatted = this.formatPrice(unformatted, this.prefix, this.decimal);
      this.formattedValue = 'loading';
      this.formattedValue = formatted;
      this.$emit('input', unformatted);
      // console.log(evt.target.value +" - "+ formatted +" - "+unformatted);
    }
  }
}
</script>

<template><input type="tel" :value="formattedValue" @change="change" /></template>
